import React from 'react'
import { Icon, Typography, makeStyles, Link } from '@material-ui/core'
import { getIconAndTagByFoundingAndMembership } from '../../utils'
import { gray } from '../../utils/colors'
import { Link as RouterLink } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
	linkStyle: {
		color: theme.palette.secondary.main,
		fontSize: '0.875rem',
		fontWeight: 600,
		lineHeight: '1.1875rem'
	},
	membershipWrapper: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center'
	},
	membershipIcon: {
		fontWeight: '900',
		fontSize: '0.875rem',
		lineHeight: '1rem',
		width: 20
	},
	membershipType: {
		fontFamily: 'Nunito',
		fontSize: '0.875rem',
		fontWeight: 600,
		lineHeight: '1.1875rem',
		color: gray[700],
		textTransform: 'capitalize'
	}
}))

/**
 *
 * @param {{
 * household_id: string,
 * founding_member: boolean,
 * accounts: [{primary: boolean, full_name: string}]
 * account: {primary: boolean, full_name: string},
 * memberships: [{type: string, deactivated: boolean, expired: boolean, end_date: string}],
 * usePrimary: boolean
 * }} props
 * @returns
 */
const ClientNameLink = ({
	household_id,
	founding_member = false,
	accounts = [],
	account,
	memberships = [],
	usePrimary = true
}) => {
	if (!household_id) {
		return 'No client'
	}

	const classes = useStyles()
	const _account = account || usePrimary ? accounts.find((a) => a.primary) : accounts[0]
	const [iconName, iconColor, tag] = getIconAndTagByFoundingAndMembership({
		memberships,
		founding_member
	})
	const membershipIconClasses = [classes.membershipIcon, iconName ? `fa fa-${iconName}` : '', iconColor].join(
		' '
	)

	return (
		<>
			<Link
				component={RouterLink}
				className={classes.linkStyle}
				onClick={(e) => e.stopPropagation()}
				to={`/clients/${household_id}/contacts`}>
				{_account ? _account.full_name || `${_account.first_name} ${_account.last_name}` : 'No name'}
			</Link>
			{!!iconName || !!tag ? (
				<div className={classes.membershipWrapper}>
					{!!iconName && <Icon className={membershipIconClasses} />}
					<Typography className={classes.membershipType}>{tag}</Typography>
				</div>
			) : null}
		</>
	)
}

export default ClientNameLink
